<script>
export default {
    props: {
        baseClass: {
            type: String,
            default: ''
        },
        additionalBaseClasses: {
            type: Array,
            default() {
                return [];
            }
        },
        styleMod: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    methods: {
        clContainer(additionalClasses = undefined) {
            return this.containerClasses.join(' ') + (additionalClasses ? ' ' + additionalClasses : '');
        },
        clSub(subClass, additionalClasses = '', useAdditionalBaseClasses = true) {
            return this.cl(subClass, '__', additionalClasses, useAdditionalBaseClasses);
        },
        clMod(modClass, additionalClasses = '', useAdditionalBaseClasses = true) {
            return this.cl(modClass, '--', additionalClasses, useAdditionalBaseClasses);
        },
        cl(classes, prefix = '', additionalClasses = '', useAdditionalBaseClasses = true) {
            if(!Array.isArray(classes)) {
                classes = [ classes ];
            }
            
            const baseClasses = useAdditionalBaseClasses ? this.baseClasses : [ this.baseClass ];
            const classNames = baseClasses.reduce((arr, curr) => { 
                return arr.concat(classes.map(c => `${curr}${prefix}${c}`))
            }, []);
            
            return (classNames.join(' ') + ' ' + additionalClasses).trim();
        }
    },
    computed: {
        baseClasses() {
            return [ this.baseClass ].concat(this.additionalBaseClasses);
        },
        containerClasses() {
            let classes = this.baseClasses;

            if(this.containerClassModifiers.length) {
                classes = classes.concat(this.baseClasses.reduce((arr, curr) => { 
                    return arr.concat(this.containerClassModifiers.map(c => `${curr}--${c}`))
                }, []));
            }

            return classes;
        },
        containerClassModifiers() {
            return this.styleMod;
        }
    }
}
</script>